import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const REFEREE_DELETE_REQUEST = 'DELETE_REFEREE_REQUEST';
export const REFEREE_DELETE_FAILURE = 'DELETE_REFEREE_FAILURE';
export const REFEREE_DELETE_SUCCESS = 'DELETE_REFEREE_SUCCESS';

export const deleteReferee = (id) => {
    const params = [];
    params['id'] = id;
    return function(dispatch) {
        dispatch(deleteRequest());
        return axios(apiRequestOptions(apiPath.REFEREE.DELETE, null, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(deleteSuccess(id));
                dispatch(addSuccessMessage('Referee successfully deleted'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const deleteRequest = () => {
    return { type: REFEREE_DELETE_REQUEST }
};

const deleteFailure = error => {
    return { type: REFEREE_DELETE_FAILURE, error }
};

const deleteSuccess = referee => {
    return { type: REFEREE_DELETE_SUCCESS, referee }
};